export function bomPartFragmentId(id: string | number): string {
	return `bom-part-${String(id)}`.replace(/\s/g, '_');
}

export function escapePartIdForSelector(id: string | number): string {
	const s = String(id);
	if (typeof CSS !== 'undefined' && typeof CSS.escape === 'function') {
		return CSS.escape(s);
	}
	return s.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
}
